import { classNames } from '@/utils';

import type { TooltipPlacement } from '@/components/base/Tooltip/types';

import { TOOLTIP_ARROW_STYLE, TOOLTIP_ARROW_VARIANT } from '@/components/base/Tooltip/styles';

type TooltipArrowProps = {
    position?: TooltipPlacement;
    variant: keyof typeof TOOLTIP_ARROW_VARIANT;
};

const Arrow = ({ position = 'bottom', variant }: TooltipArrowProps) => {
    const mainPosition = position.split('-')[0] as keyof typeof TOOLTIP_ARROW_STYLE;
    const isTop = mainPosition === 'top';
    const isBottom = mainPosition === 'bottom';
    const isRight = mainPosition === 'right';
    const isLeft = mainPosition === 'left';

    return (
        <div
            data-testid="tooltip-arrow"
            style={TOOLTIP_ARROW_STYLE[mainPosition]}
            className={classNames('relative h-1.5 w-3', TOOLTIP_ARROW_VARIANT[variant], {
                '-bottom-1.5': isTop,
                '-top-1.5': isBottom,
                '-right-3': isLeft,
                '-left-3': isRight
            })}
            data-popper-arrow={position}
        />
    );
};

export default Arrow;
